import {Injectable} from '@angular/core';

@Injectable({providedIn: 'root'})
export class PrimeNGConfig {
    ripple: boolean = false;
}